import { apiKeyHeader } from "../../configs/ApiKeys";
import axios from "axios";

export async function GETAPIREQUEST(url, type, rejectWithValue) {
  try {
    try {
      const resp = await axios.get(url, { headers: apiKeyHeader() });
      return resp?.data;
    } catch (error) {
      const errData = error?.response?.data || {};
      return rejectWithValue(errData.message || "Failed to fetch " + type);
    }
  } catch (err) {
    return rejectWithValue("Network error while fetching " + type);
  }
}

export async function POSTAPIREQUEST(url, type, rejectWithValue, body) {
  try {
    try {
      const resp = await axios.post(url, body, { headers: apiKeyHeader() });
      return { data: resp?.data, body };
    } catch (error) {
      const errData = error?.response?.data || {};
      return rejectWithValue(errData.message || "Failed to save " + type);
    }
  } catch (err) {
    return rejectWithValue("Network error while saving " + type);
  }
}

export const createThunkCases = (
  builder,
  thunk,
  customErrorMsg,
  successChanges = null,
  errorChanges = null
) => {
  builder
    .addCase(thunk.pending, (state, action) => {
      state.loader = true;
      state.error = null;

      if (typeof errorChanges === "function") {
        errorChanges(state, action);
      }
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.loader = false;
      state.error = null;

      if (typeof successChanges === "function") {
        successChanges(state, action);
      }
    })
    .addCase(thunk.rejected, (state, action) => {
      state.loader = false;
      state.error = action?.payload || action?.error?.message || customErrorMsg;

      if (typeof errorChanges === "function") {
        errorChanges(state, action);
      }
    });
};

export const allModulesList = [
  { id: 1, name: "Event Organiser" },
  { id: 2, name: "Question Paper" },
  { id: 3, name: "Time Table" },
  { id: 4, name: "Academic Calendar" },
  { id: 6, name: "Teachers Planner" },
  // { id: 5, name: "Documents (Complimentary - free with the plan)" },
  // { id: 5, name: "Documents- free with Complimentary plan" },
  // { id: 5, name: "Only Documents to be written in Complete Modules Section" },
  { id: 5, name: "Documents" },
];
